import { tWithKey } from "@/lib/i18n-fallback";
import { MULTIPLEPRINT_NATURES, MultipleprintNature } from "@/lib/types";

type TranslateFn = Parameters<typeof tWithKey>[0];

export const multipleprintNatureLabel = (
  t: TranslateFn,
  nature: MultipleprintNature,
) =>
  nature === "portfolio"
    ? tWithKey(t, "multipleprint.nature.portfolio", "Portfolio")
    : tWithKey(t, "multipleprint.nature.simple", "Multiple simple");

export const multipleprintNatureOptions = (t: TranslateFn) =>
  MULTIPLEPRINT_NATURES.map((nature) => ({
    value: nature,
    label: multipleprintNatureLabel(t, nature),
  }));

export const multipleprintNatureFieldLabel = (t: TranslateFn) =>
  tWithKey(t, "estampesMultiplesNature", "Nature du multiple");
